import {
  computePersistentEffects,
  type AchievementPersistentEffects,
} from "@/features/achievements/achievementEffects";
import type { AchievementsState } from "@/features/achievements/types";

export interface InitialGameAppAchievementPersistentEffectsOptions {
  readonly sessionAchievementsState: AchievementsState;
  readonly e2eAchievementsState?: AchievementsState | null;
}

export function resolveInitialGameAppAchievementPersistentEffects(
  options: InitialGameAppAchievementPersistentEffectsOptions,
): AchievementPersistentEffects {
  const achievementsState =
    options.e2eAchievementsState ?? options.sessionAchievementsState;
  return computePersistentEffects(achievementsState.unlockedIds);
}
